__turbopack_context__.v({
  "descriptionPolicy": "style-module__jQCQwq__descriptionPolicy",
  "img": "style-module__jQCQwq__img",
  "privacy": "style-module__jQCQwq__privacy",
  "privacyBanner": "style-module__jQCQwq__privacyBanner",
});
